import { Link } from "react-router-dom";

export default function  (props) {
  return (

    <div className="nav">
      <Link to="/">
        <h2>Home Page</h2>
      </Link>
    </div>
  );
}
